var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBeta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "24px",
    viewBox: "0 0 47 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-beta") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RenBridge_v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Minting-5-Copy-3",
    transform: "translate(-262.000000, -50.000000)",
    fill: "#8A8A90",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-beta",
    transform: "translate(262.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,0.25 L7,0.25 C3.27207794,0.25 0.25,3.27207794 0.25,7 L0.25,17 C0.25,20.7279221 3.27207794,23.75 7,23.75 L40,23.75 C43.7279221,23.75 46.75,20.7279221 46.75,17 L46.75,7 C46.75,3.27207794 43.7279221,0.25 40,0.25 Z M7,1.75 L40,1.75 C42.8994949,1.75 45.25,4.10050506 45.25,7 L45.25,17 C45.25,19.8994949 42.8994949,22.25 40,22.25 L7,22.25 C4.10050506,22.25 1.75,19.8994949 1.75,17 L1.75,7 C1.75,4.10050506 4.10050506,1.75 7,1.75 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.152,17 C12.21,17 13.862,16.16 13.862,14.004 C13.862,12.702 13.246,12.002 12.336,11.596 C12.994,11.218 13.456,10.35 13.456,9.398 C13.456,7.34 11.72,6.85 9.858,6.85 L6.12,6.85 L6.12,17 L10.152,17 Z M10.054,11.148 L7.716,11.148 L7.716,8.166 L10.054,8.166 C11.118,8.166 11.846,8.628 11.846,9.594 C11.846,10.686 11.146,11.148 10.054,11.148 Z M10.194,15.684 L7.716,15.684 L7.716,12.38 L10.11,12.38 C11.552,12.38 12.224,12.884 12.224,14.004 C12.224,15.082 11.552,15.684 10.194,15.684 Z M23.028,17 L23.028,15.642 L17.596,15.642 L17.596,12.45 L22.72,12.45 L22.72,11.106 L17.596,11.106 L17.596,8.208 L23.028,8.208 L23.028,6.85 L16,6.85 L16,17 L23.028,17 Z M28.862,17 L28.862,8.208 L32.11,8.208 L32.11,6.85 L24.004,6.85 L24.004,8.208 L27.266,8.208 L27.266,17 L28.862,17 Z M33.254,17 L34.038,14.774 L38.448,14.774 L39.246,17 L40.982,17 L37.16,6.85 L35.396,6.85 L31.63,17 L33.254,17 Z M37.958,13.43 L34.514,13.43 L36.222,8.586 L37.958,13.43 Z",
    id: "BETA"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBeta);
export default __webpack_public_path__ + "static/media/icon-beta.897aefdf088fe9a4ee15385cbd5cfdbd.svg";
export { ForwardRef as ReactComponent };